<!-- Bill: the inbox's panel, document preview beside the form, approval block in the form's footer. -->
<div class="rph rph--invoice" *ngIf="panelKey === 'invoice'" [class.rph--narrow]="!hasDocument">
  <app-add-new-invoice-page [isEmbedded]="true" [invoiceId]="recordId" [embeddedEditMode]="true"
    (closed)="close()" (hasDocumentChange)="hasDocument = $event"
    (invoicePublished)="close()" (onDeleteDocument)="close()">
  </app-add-new-invoice-page>
</div>

<!-- Supplier and payment: the side navs their own pages open. -->
<div class="sidenav sidenav-show supplier-contact-sidenav rph rph--nav" *ngIf="panelKey === 'supplier'">
  <div class="sidenav_in cd_sidebar">
    <div class="reports_tab">
      <div class="form-group">
        <app-supplier-contancts [billsToPayMode]="false" [supplierTabMode]="true" [isEditable]="true"
          (closeFormEvent)="close()">
        </app-supplier-contancts>
      </div>
    </div>
  </div>
</div>

<div class="sidenav sidenav-show payment-drawer rph rph--nav" *ngIf="panelKey === 'payment'">
  <div class="sidenav_in">
    <div class="form-group">
      <ng-template [cdkPortalOutlet]="paymentPortal" (attached)="onPaymentAttached($event)"></ng-template>
    </div>
  </div>
</div>
